module.exports = __webpack_public_path__ + "img/ninjax.ddc793cb.png";